import { zlbApiExpenseCommonDicGetPost } from '@/api/zlbExpense';
import { sleep } from '@/utils/utils';
import { get } from 'lodash';
import {
  batchGetDebitNoteList,
  deleteSmallTransfer,
  disCardSmallTransfer,
  getAccountSubject,
  getAutomaticDeductionList,
  getBudgetAccountSubjectList,
  getCarryOverPaymentConfigSubjects,
  getCarryOverPaymentList,
  getCarryOverPaymentOverview,
  getCollectionDetailsList,
  getDebitNoteList,
  getDebitNoteListNew,
  getGroupAccountSubject,
  getSmallTransferDetail,
  getTransferRepaymentList,
  // getSmallTransferNotUse,
  getTuoshouAccountSubject,
  requestBankCardList,
  saveSmallTransfer,
  smallTransferInit,
  submitSmallTransfer,
  syncBalanceAccount,
  useTemplate,
} from '../services';

export default {
  namespace: 'smallEntrust',
  state: {
    desensitize: 0, // 未关联明细的数量
    initData: {}, // 托收明细初始化数据
    bankCardList: [], // 银行账户列表
    groupAccountSubject: [], // 集团账户对应科目
    tuoshouAccountSubject: [], // tuoshou 账户对应科目
    subjectList: [], // 银行关联科目
    // smallTransferNotUseQuantity: 0, // 托付扣款凭证待处理数量

    config: {
      isPersonal: false,
      configSubjects: [],
    }, // 小额托收配置
    overview: {}, // 托收总览
    // 模式对应账户跟科目
    accountSubjectMap: {
      // 公务卡
      official: {
        account: [],
        subject: [],
      },
      // 基本账户
      basic: {
        account: [],
        subject: [],
      },
    },
  },
  effects: {
    // 获取明细列表
    *getDebitNoteList({ payload }, { call }) {
      const result = yield call(getDebitNoteList, payload);
      return result;
    },
    // 扣款凭证列表，新版
    *getDebitNoteListNew({ payload }, { call }) {
      // console.log('payload: ', payload);
      // return Promise.resolve(mockDebitNoteListNew?.result);
      const result = yield call(getDebitNoteListNew, payload);
      return result;
    },

    // 获取账户配置
    *getBankCardList({ payload }, { call, put }) {
      const result = yield call(requestBankCardList, payload);
      yield put({
        type: 'update',
        payload: {
          bankCardList: result?.data || [],
        },
      });
      return result;
    },

    // 获取集团账户对应科目
    *getGroupAccountSubject({ payload }, { call, put }) {
      const result = yield call(getGroupAccountSubject, payload);
      yield put({
        type: 'update',
        payload: {
          groupAccountSubject: result || [],
        },
      });
      return result;
    },

    // 获取托收账户对应科目
    *getTuoshouAccountSubject({ payload }, { call, put }) {
      const result = yield call(getTuoshouAccountSubject, payload);
      yield put({
        type: 'update',
        payload: {
          tuoshouAccountSubject: result || [],
        },
      });
      return result;
    },
    //  单位账户余额同步
    *syncBalanceAccount({ payload }, { call, put }) {
      try {
        const result = yield call(syncBalanceAccount, payload);
        return result;
      } catch (error) {
        console.log('同步失败');
      } finally {
        // 确保无论成功失败都更新loading状态
        yield put({ type: 'setLoading', payload: false });
      }
    },
    // 获取科目列表
    *getSubjectList({ payload }, { call, put }) {
      const result = yield call(getBudgetAccountSubjectList, payload);
      yield put({
        type: 'update',
        payload: {
          subjectList: result || [],
        },
      });
      return result;
    },

    *smallTransferInit({ payload }, { call, put }) {
      const result = yield call(smallTransferInit, payload);
      yield put({
        type: 'update',
        payload: {
          initData: result,
        },
      });
      return result;
    },

    *saveSmallTransfer({ payload }, { call }) {
      const result = yield call(saveSmallTransfer, payload);
      return result;
    },
    *submitSmallTransfer({ payload }, { call }) {
      const result = yield call(submitSmallTransfer, payload);
      return result;
    },

    *deleteSmallTransfer({ payload }, { call }) {
      const result = yield call(deleteSmallTransfer, payload);
      return result;
    },
    *disCardSmallTransfer({ payload }, { call }) {
      const result = yield call(disCardSmallTransfer, payload);
      return result;
    },
    *getCollectionDetailsList({ payload }, { call, put }) {
      const result = yield call(getCollectionDetailsList, payload);
      // 仅onlyDisplayNoSummaryData参数下，为获取未关联明细的数量
      if (Object.keys(payload).toString() === 'onlyDisplayNoSummaryData') {
        yield put({
          type: 'update',
          payload: {
            desensitize: result?.total || 0,
          },
        });
      }
      return result;
    },

    *getSmallTransferDetail({ payload }, { call, put }) {
      const result = yield call(getSmallTransferDetail, payload);
      yield put({
        type: 'update',
        payload: {
          initData: result,
        },
      });
      return result;
    },

    // 结转支付查询列表
    *getCarryOverPaymentList({ payload }, { call }) {
      const result = yield call(getCarryOverPaymentList, payload);
      return result;
    },

    // 小额托收的批量获取
    *batchGetDebitNoteList({ payload }, { call }) {
      const result = yield call(batchGetDebitNoteList, payload);
      return result;
    },

    // 废弃
    // *getSmallTransferNotUse({ payload }, { call, put }) {
    //   const result = yield call(getSmallTransferNotUse, payload);
    //   yield put({
    //     type: 'update',
    //     payload: {
    //       smallTransferNotUseQuantity: result,
    //     },
    //   });
    //   return result;
    // },

    // 使用模板，自动生成模板明细
    *useTemplate({ payload }, { call, put, select }) {
      const result = yield call(useTemplate, payload);
      // 获取当前initData数据
      const temp = yield select((state: any) => state.smallEntrust.initData);
      // 替换明细信息
      temp.restDetailList = result || [];
      yield put({
        type: 'update',
        payload: {
          initData: temp,
        },
      });
      return result;
    },

    *getCarryOverPaymentConfig({ payload }, { call, put, select }) {
      const result = yield call(zlbApiExpenseCommonDicGetPost, [
        {
          typeCode: 'COLLECTION_BUSINESS_FORM',
          subTypeCodeList: ['config_collection_business_mode_switch'],
        },
      ]);
      const isPersonal = get(result?.[0], 'values')?.some(
        item => item.code === 'config_collection_business_mode_business_card',
      );
      yield put({
        type: 'updateConfig',
        payload: {
          isPersonal,
        },
      });
      return result;
    },

    // 获取小额托收配置的科目
    *getCarryOverPaymentConfigSubjects({ payload }, { call, put }) {
      const result = yield call(getCarryOverPaymentConfigSubjects, payload);
      yield put({
        type: 'updateConfig',
        payload: {
          configSubjects: result || [],
        },
      });
      return result;
    },

    *getCarryOverPaymentOverview({ payload }, { call, put }) {
      const result = yield call(getCarryOverPaymentOverview, payload);
      yield put({
        type: 'update',
        payload: {
          overview: result,
        },
      });
      return result;
    },
    // 代扣还款个人列表
    *getAutomaticDeductionList({ payload }, { call }) {
      yield sleep(1500);
      const result = yield call(getAutomaticDeductionList, payload);
      return result;
    },
    // 代扣还款单位列表
    *getTransferRepaymentList({ payload }, { call }) {
      yield sleep(1500);
      const result = yield call(getTransferRepaymentList, payload);
      return result;
    },
    // 获取新版托收关联会计科目
    *getAccountSubject({ payload }, { call, put, select }) {
      const { type, accountLevel } = payload;
      // 获取账户
      const account = yield call(requestBankCardList, {
        accountType: 6,
        accountLevel,
      });
      // 获取账户关联会计科目
      const subject = yield call(getAccountSubject, {
        year: new Date().getFullYear(), // 取当前年
        accountType: 6,
        accountLevel,
      });

      // 合并数据
      const accountSubjectMap = yield select((state: any) => state.smallEntrust.accountSubjectMap);
      accountSubjectMap[type] = {
        account: account?.data || [],
        subject: subject || [],
      };
      yield put({
        type: 'update',
        payload: {
          accountSubjectMap,
        },
      });
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    updateConfig(state, { payload }) {
      return {
        ...state,
        config: {
          ...state.config,
          ...payload,
        },
      };
    },
  },
};
